import PosInquiry from '@/components/public/posInquiry/PosInquiry';

const PosInquiryPage = (): JSX.Element => {
    return <PosInquiry />;
};

export default PosInquiryPage;
